import { call, put, takeLatest } from "redux-saga/effects";
import { khoaApi } from "../../../api/category/khoaApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { eDmKhoaActionIds } from "../../action-types/category/IDmKhoaActions";

export function* khoaSaga(): any {
  yield takeLatest(eDmKhoaActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(khoaApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.khoa.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.khoa.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
